import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";
import { TranslationService } from "@obg/ngx.core.content";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { RegionAction } from "./region.action";
import { REGIONS_CRS_GROUP_KEY } from "./region.const";
import { RegionSelector } from "./region.selector";

/**
 * @deprecated [fabric-deprecated] - use fabric RegionService from svc-content instead
 */
@Injectable()
export class RegionEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(ContentServiceCommand.GetAllRegions)" instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(RegionAction.getAll),
			withLatestFrom(this.store.select(RegionSelector.getAll)),
			filter(([, regions]) => !regions?.length),
			switchMap(() =>
				this.translationService.getTranslationGroupByNames([REGIONS_CRS_GROUP_KEY]).pipe(
					map((feed) => {
						const prefix = REGIONS_CRS_GROUP_KEY.toLowerCase() + ".";
						const regExp = new RegExp(/[Rr]egions\.[a-zA-Z0-9-]{1,32}/);
						const transformedRegions = feed
							? Object.keys(feed)
									.filter((key) => typeof feed[key] === "string" && regExp.test(key))
									.map((key) => ({
										value: key.substring(prefix.length).toUpperCase(),
										name: feed[key],
									}))
							: undefined;
						return RegionAction.getAllSuccess(transformedRegions);
					}),
					catchError((error: AppError) => of(RegionAction.getAllFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private translationService: TranslationService,
		private store: Store<CommonState>
	) {}
}
